module.exports = __webpack_public_path__ + "img/logo_fr.13a3a9c.svg";